import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/AddVenue.css';

function AddVenue() {
  const [newVenueName, setVenueName] = useState('');
  const [newVenueAddress, setVenueAddress] = useState('');
  const [status, setStatus] = useState(null);      // null | 'success' | 'error'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { user_id } = useParams();

  const handleAddVenue = async () => {
    setStatus(null);
    try {
      // ⚡️ Switch to a proper POST with JSON body
      const res = await fetch(
        'https://api.bestday2marry.com/add_venue/',
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            venue_name: newVenueName,
            venue_address: newVenueAddress
          }),
        }
      );
      const json = await res.json();
      if (res.status !== 200 || json.status !== 'success') {
        throw new Error(json.status || 'Server rejected add_venue');
      }

      // auto-select for the user (you can keep the query-param version here)
      await fetch(
        `https://api.bestday2marry.com/select_venue/?user_id=${encodeURIComponent(
          user_id
        )}&venue_name=${encodeURIComponent(newVenueName)}`,
        {
          method: 'POST',
          credentials: 'include',
        }
      );

      setStatus('success');
      setMessage(
        "Thanks! Your venue is recorded and pending review. We'll notify you when it's live—meanwhile you can go back to your dashboard."
      );
    } catch (err) {
      console.error(err);
      setStatus('error');
      setMessage(
        'Oops—could not record your venue. Please check your network or try again later.'
      );
    }
  };

  // after successful add, show confirmation & return to dashboard
  if (status === 'success') {
    return (
      <div className="add-venue-container">
        <div className="logo">BestDay2Marry</div>
        <h1>Venue Submitted</h1>
        <p>{message}</p>
        <button
          className="medium-button"
          onClick={() => navigate(`/dashboard/${user_id}`)}
        >
          Return to Dashboard
        </button>
      </div>
    );
  }

  // default form
  return (
    <div className="add-venue-body">
      <div className="add-venue-container">
        <div className="logo">BestDay2Marry</div>
        <h1>Add Your Venue</h1>

        <div className="form-group">
          <input
            type="text"
            placeholder="Venue name"
            value={newVenueName}
            onChange={(e) => setVenueName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <input
            type="text"
            placeholder="Venue address"
            value={newVenueAddress}
            onChange={(e) => setVenueAddress(e.target.value)}
          />
        </div>

        {status === 'error' && <p className="error-message">{message}</p>}

        <button className="submit" onClick={handleAddVenue}>
          Submit
        </button>
        <button className="back-button" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>
    </div>
  );
}

export default AddVenue;